import React, { useEffect, useState, useRef } from 'react';
import { searchTenantCosts } from '../../api/sportaloka-client';
import ClickOutside from '../helper/ClickOutside';
import clsx from 'clsx';

function SelectMasterCost(props) {
  const { onBlur, onChange, value, isError, errorMessage, style, placeholder, disabled } = props;

  const [visibility, setVisibility] = useState(false);
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const [reachMax, setReachMax] = useState(false);
  const [error, setError] = useState(false);
  const [paginationOptions, setPaginationOptions] = useState({
    page: 1,
    limit: 10,
    description: ''
  });

  const searchInputRef = useRef(null);

  const getData = async () => {
    try {
      setReachMax(false);
      setLoading(true);
      setError(false);
      const query = new URLSearchParams({
        page: paginationOptions.page,
        limit: paginationOptions.limit,
        description: paginationOptions.description
      }).toString();
      const response = await searchTenantCosts(query);
      const responseData = response.data.data.data;

      if (responseData.length === 0) {
        setReachMax(true);
      }

      setData(data.concat(responseData));
      setTotalRows(totalRows);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };

  const handleNext = () => {
    setPaginationOptions({ ...paginationOptions, page: paginationOptions.page + 1 });
  };

  const handleSearch = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      setData([]);
      setReachMax(false);
      setPaginationOptions({
        ...paginationOptions,
        page: 1,
        description: event.target.value ?? ''
      });
    }
  };

  const handleSearchButton = (event) => {
    event.preventDefault();
    setData([]);
    setReachMax(false);
    setPaginationOptions({ ...paginationOptions, page: 1, description: event.target.value ?? '' });
  };

  const handleSelect = (row) => {
    if (onChange) {
      onChange({ value: row.id, label: row.description });
    }
    handleBlur();
  };

  const handleFocus = () => {
    if (!disabled) {
      setVisibility(true);
      if (searchInputRef.current) {
        searchInputRef.current.focus();
      }
    }
  };

  const handleClear = () => {
    if (onChange) {
      onChange(null);
    }
    handleBlur();
  };

  const handleBlur = () => {
    setVisibility(false);
    if (onBlur) {
      onBlur();
    }
  };

  useEffect(() => {
    if (visibility) {
      getData();
    }
  }, [paginationOptions]);

  useEffect(() => {
    if (visibility) {
      setData([]);
      setReachMax(false);
      setPaginationOptions({ ...paginationOptions, page: 1, description: '' });
    }
  }, [visibility]);

  return (
    <ClickOutside onClick={handleBlur}>
      <div className={clsx(`custom-select`, { 'form-input': !style }, { 'form-group': style })}>
        <label
          className={clsx(
            { 'lh-1 text-14 text-light-1 fw-500': !style },
            { 'mb-0': true },
            { search__label: style }
          )}>
          Master Biaya
        </label>
        <input
          style={{ width: 200, height: 38 }}
          disabled={disabled}
          onClick={handleFocus}
          className={clsx(
            { 'bg-white': true },
            { 'custom-select__input': !style },
            { 'form-control search__input': style },
            { 'border-danger': isError }
          )}
          readOnly
          placeholder={placeholder ? placeholder : ''}
          value={value ? value.label : ''}
        />
        {visibility && (
          <div className="custom-select__dropdown" style={{ top: 68 }}>
            <ul>
              <li className="custom-select__search">
                <input type="text" placeholder="Pencarian..." onKeyDown={handleSearch} />
                <span onClick={handleSearchButton} className="custom-select__search__button">
                  <i className="fa fa-search text-blue-1 text-20"></i>
                </span>
              </li>
              {data.length > 0 &&
                data.map((row) => (
                  <li
                    key={row.id}
                    className="custom-select__dropdown__item"
                    onClick={() => handleSelect(row)}>
                    {row.description}
                  </li>
                ))}
              {loading && <li className="custom-select__dropdown__action">Memuat...</li>}
              {!loading && !error && data.length > 0 && !reachMax && (
                <li className="custom-select__dropdown__action" onClick={handleNext}>
                  <span className="text-blue-1 fw-600 cursor-pointer">Lihat Selanjutnya</span>
                </li>
              )}
              {!loading && !error && data.length === 0 && (
                <li className="custom-select__dropdown__action">Data Tidak Ditemukan</li>
              )}
              {error && (
                <li className="custom-select__dropdown__action">
                  Gagal mendapatkan data,{' '}
                  <span onClick={getData} className="text-danger fw-600 cursor-pointer">
                    Coba lagi
                  </span>
                </li>
              )}
            </ul>
          </div>
        )}
        {value && (
          <div className="custom-select__clear">
            <div className="cursor-pointer" onClick={handleClear}>
              <i className={`fa fa-close text-20 text-danger`} />
            </div>
          </div>
        )}
        <div className="custom-select__toggler">
          <div className="cursor-pointer" onClick={handleFocus}>
            <i className={`fa fa-caret-down text-30 text-blue-1`} />
          </div>
        </div>
      </div>
      {isError && errorMessage && (
        <span className="text-danger text-14 fw-normal">{errorMessage}</span>
      )}
    </ClickOutside>
  );
}

export default SelectMasterCost;
